export default {"src":"/_next/static/media/shield_cat_ic.d6a480bb.svg","height":120,"width":120};